import React, { useState, useRef, useEffect} from "react";
import { MapContainer, TileLayer, FeatureGroup, useMap } from 'react-leaflet';
// import CustomMenuMouse from './Menu/CustomMenuMouse'; 
// import DrawingLineHandler from './Drawing/DrawingLineHandler'; 
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import SwapCallsRoundedIcon from '@mui/icons-material/SwapCallsRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import DescriptionIcon from '@mui/icons-material/Description';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Tooltip } from '@mui/material';
import axios from 'axios';
import {loadingCanton, loadingRegionsData, loadingAreaData, loadingCity} from"../Optics/LoadingData/LoadingDataTerritory";  
// import {GetHighwayFilter, GetCantonFilter, GetCantonFilterRefresh, GetHighwayFilterRefresh, GetCantonFobFilterRefresh, GetCantonCouplingFilterRefresh, GetCantonWellFilterRefresh, GetCantonPillarFilterRefresh, GetCantonPonBoxFilterRefresh, GetCantonCableFilterRefresh} from './TerritoryFilter/FilterGetTerritory'      
 import CableShowDisplay  from '../Optics/CableDisplay/CableShowDisplay';
// import ModalDeleteComponent from './Modal/ModalDeleteComponent'
// import ModalDescriptionComponent from "./Modal/ModalDescriptionComponent";
// import ModalSearchComponentMap from "./Modal/ModalSearchComponentMap";
// import TerritoryInfo from "./TerritoryFilter/TerritoryInfo";
// import ShowLengthCable from "./Drawing/ShowLengthCable";
import ModalEditingCable from "../Optics/Drawing/ModalEditingCable";
// import GetSwitchesMapLocation from "./TerritoryFilter/GetSwitchesMapLocation";
// import MarkersEditing from "./Markers/MarkersEditing";
// import MarkersViewing from "./Markers/MarkersViewing";
// import MarkersTwoIconViewing from "./Markers/MarkersTwoIconViewing";
// import MarkersEditingCoupling from "./Markers/MarkersEditingCoupling";
// import MarkersEditingFob from "./Markers/MarkersEditingFob";
// import { ROLE_ADMIN, ROLE_ENGINNER } from "./Constants/ConstantsOptics";
import L from 'leaflet';
// import * as turf from '@turf/turf';
// import MarkerPoligonToClick from "./Markers/MarkerPoligonToClick";
// import LinkEditingHighway from "./Drawing/LinkEditingHighway";
  import LinkEditingCanton from "../Optics/Drawing/LinkEditingCanton";

// import { CONST_CANTON, CONST_HIGHWAY } from "./Constants/ConstantsOptics";
// import MarkersEditingPonBox from "./Markers/MarkersEditingPonBox";
// import ShowRuler from "./Drawing/ShowRuler";
import CustomDrawPolyline from "../Optics/Components/CustomDrawPolyline";
// import ModalRouteCableMap from "./Modal/ModalRouteCableMap";
// import MarkersViewingPillar from "./Markers/MarkersViewingPillar";
// import MarkersTwoIconViewingCoupling from "./Markers/MarkersTwoIconViewingCoupling";
// import MarkersTwoIconViewingFob from "./Markers/MarkersTwoIconViewingFob";
// import MarkersViewingPonBox from "./Markers/MarkersViewingPonBox";
// import MarkersViewingAmplifier from "./Markers/MarkersViewingAmplifier";
// import MarkersViewingOp from "./Markers/MarkersViewingOp";
// import ErrorIcon from '@mui/icons-material/Error';
// import ModalFasteningErrors from "./Modal/ModalFasteningErrors";
import 'leaflet-geometryutil';
import DrawerViewingConstruct from "./DraverConstruction/DrawerViewingConstruct";
import { GetCantonFilter } from "../Optics/TerritoryFilter/FilterGetTerritory";
import { useLocation } from "react-router-dom";
import ProjectInfo from "./Modals/ProjectInfo";
import { GetCableByIdFilterRefreshConstructor, GetCableFilterRefreshConstructor, GetCableIdConstructionRefresh, GetCantonCableFilterRefresh, GetCantonCouplingFilterRefreshConstruction, GetCantonFobFilterRefreshConstruction, GetCantonPoligon, GetCantonPonBoxFilterRefreshConstruction } from "./Data/GetProjectTerritory";
import GetHousesMapLocation from "./Territory/GetHousesMapLocation";
import DrawerEditComponent from "./DraverConstruction/DrawerEditComponent";
import DrawingLineHandler from "../Optics/Drawing/DrawingLineHandler";
import ShowLengthCable from "../Optics/Drawing/ShowLengthCable";
import CustomMenuMouse from "../Optics/Menu/CustomMenuMouse";
import MarkerPoligonToClick from "../Optics/Markers/MarkerPoligonToClick";
import MarkersEditingCoupling from "../Optics/Markers/MarkersEditingCoupling";
import { CONST_CANTON, CONST_CANTON_COUPLING, CONST_CANTON_FOB, CONST_CANTON_PON_BOX, CONST_HIGHWAY_COUPLING, CONST_HIGHWAY_FOB, COUPLING, COUPLING_FLAG, FOB, FOB_FLAG, iconCoupling, iconCouplingCanton, iconFob, iconFobCanton, iconPonBox, PON_BOX, PON_BOX_FLAG } from "../Optics/Constants/ConstantsOptics";
import MarkersTwoIconViewingCoupling from "../Optics/Markers/MarkersTwoIconViewingCoupling";
import MarkersEditingFob from "../Optics/Markers/MarkersEditingFob";
import MarkersTwoIconViewingFob from "../Optics/Markers/MarkersTwoIconViewingFob";
import MarkersEditingPonBox from "../Optics/Markers/MarkersEditingPonBox";
import MarkersViewingPonBox from "../Optics/Markers/MarkersViewingPonBox";
import DescriptionComponentModalConstr from "./Modals/DescriptionModal/DescriptionComponentModalConstr";
import { EditingCableLineConstruction } from "./WriteData/WriteConstructCommunications";
import EditingLineCableConstruct from "./Modals/EditingLocation/EditingLineCableConstruct";
import MarkersTwoIconViewingCouplingConstruct from "./Marker/MarkersTwoIconViewingCouplingConstruct";
import MarkersTwoIconViewingFobConstruction from "./Marker/MarkersTwoIconViewingFobConstruction";
import MarkersViewingPonBoxConstructor from "./Marker/MarkersViewingPonBoxConstructor";
import ModalEstimate from "./Modals/Estimate/ModalEstimate";
import CableShowDisplayConstruct from "./Polyline/CableShowDisplayConstruct";
import ShowRuler from "../Optics/Drawing/ShowRuler";
import MarkersAmplifierPassiveNode from "./Marker/MarkersAmplifierPassiveNode";
import { useSearchParams } from "react-router-dom";
import { GET_PROJECT_BY_ID_API_URL } from "../Optics/OpticApiConfig";
// import ModalEditingProblemCable from "./Drawing/ModalEditingProblemCable";
// import MarkersViewingProblemCable from "./Markers/MarkersViewingProblemCable";
// import MarkersViewingDivider from "./Markers/MarkersViewingDivider";
// import MarkerPoligonToClickDistance from "./Markers/MarkerPoligonToClickDistance";
// import CustomSnackbar from "./Components/CustomSnackbar";
// import { WriteLineOpticCanton } from "./WriteData/WriteCantonCommunications";



const MainConstructorMap = () => {

  const [polylinePoints, setPolylinePoints] = useState([]);
  const[lineId, setLineId] = useState();
  const polylinesRef = useRef({});
  const [lengthCableEditing, setLengthCableEditing] = useState(0);
  const [lengthCableSegment, setLengthCableSegment] = useState(0);
  const [lineEditing, setLineEditing] = useState([]);
  const [selectedRankCouling, setSelectedRankCoupling] = useState(null);
  const [polyline, setPolyline] = useState(null);
  const [searchParams] = useSearchParams();
  const projectIdFromUrl = searchParams.get("projectId");
  const [project, setProject] = useState(null);
  const [copied, setCopied] = useState(false);


//  const location = useLocation();
//   const { project } = location.state || {};

useEffect(() => {
  const key = window.location.hash.substring(1);
  const id = searchParams.get("projectId");

  if (key) {
    const data = sessionStorage.getItem(key);
    if (data) {
      setProject(JSON.parse(data));
      return;
    }
  }

  if (id) {
    fetchProjectById(id);
  }
}, []);

const fetchProjectById = async (id) => {

  try {
    const res = await axios.get(
      `${GET_PROJECT_BY_ID_API_URL}?id=${id}`
    );
    setProject(res.data);
  } catch (err) {
    console.error("Ошибка загрузки проекта", err);
  }
};

  const generateLink = async () => {
    if (!project?.id) return;

    const url = `${window.location.origin}/constructionmap?projectId=${project.id}`;

    await navigator.clipboard.writeText(url);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };


  //   const [project] = useState(() => {
  //   const key = window.location.hash.substring(1); 
  //   if (key) {
  //     const data = sessionStorage.getItem(key);
  //     return data ? JSON.parse(data) : null;
  //   }
  //   return null;
  // });



   const [user, setUser] =  useState(localStorage.getItem('username'));

  useEffect(() => {
  if (project) {
    handleClickCanton();
  }
}, [project]);


  const handlePolylineRef = (id, ref) => {
    polylinesRef.current[id] = ref;
  };

  const[lineMarkerId, setLineMarkerId] = useState();

  

  //#region ПЕРЕМЕННЫЕ

  //Drawer
  const [openEditCantonDrawer, setOpenEditCantonDrawer] = useState(false);
  const [openEditSummitDrawer, setOpenEditSummitDrawer] = useState(false);
  const [openViewingDrawer, setOpenViewingDrawer] = useState(false);
  const [selectedCanton, setSelectedCanton] = useState([]);
  const [selectedRegoin, setSelectedRegion] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [regions, setRegions] = useState([]);
  const [canton, setCanton] = useState([]);
  const selectedRegionRef = useRef(null);
  const [area, setArea] = useState([]);
  const selectedAreaRef = useRef(null);
  const [selectedCity, setSelectedCity] = useState([]);
  const [city, setCity] = useState([]);
  const [selectCityIsСhange, setSelectCityIsСhange] = useState(null);
  const [selectCantonIsСhange, setSelectCantonIsСhange] = useState(null);
  const [highwayTerritory, setHighwayTerritory] = useState(false);
  const [cantonTerritory, setCantonTerritory] = useState(false);
  const [rulerStatus, setRulerStatus] = useState(false);
  const drawnItemsRef = useRef(new L.FeatureGroup());

  // map
  const mapRef = useRef();
  const polylineHandlerRef = useRef(null);

  // modal
  const [openModal, setOpenModal] = useState(false);
  const [statusModalTerritory, setStatusModalTerritory] = useState('');
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [markerType, setMarkerType] = useState('');
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalRouteCable, setOpenModalRouteCable] = useState(false);
  const [openModalLog, setOpenModalLog] = useState(false);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [openFasteningErrors, setOpenModalFasteningErrors] = useState(false);

  

  // menu
  const [menuPosition, setMenuPosition] = useState(null);
 
  //poligon
  const [housesData, setHousesData] = useState([]);

  // оборудование
  const [switchesData, setSwitchesData] = useState([]);
  const [showPolygonsArea, setShowPolygonsArea] = useState(false);
  const [showPolygonsCanton, setShowPolygonsCanton] = useState(false);
  const [showHouses, setShowHouses] = useState(true);
  const [showHousesActiv, setShowHousesActiv] = useState(false);
  const [showHousesNoActiv, setShowHousesNoActiv] = useState(false);

  
  // cable
  const [selectedLineColor, setSelectedLineColor] = useState();
  const [selectedLineWidth, setSelectedLineWidth] = useState();
  const [coordinatesCableLine, setCoordinatesCableLine] = useState([]);
  const [cableOpticId, setCableOpticId] = useState();
  const [cableTypeId, setCableTypeId] = useState();
  const [cableKind, setCableKind] = useState();
  const [isLineDrawing, setIsLineDrawing] = useState(false);
  const [groupedCoordinatesWithColorTypeAndWidth, setGroupedCoordinatesWithColorTypeAndWidth] = useState({});
  const [descriptionOptic, setDescriptionOptic] = useState({});
  const [showLines, setShowLines] = useState(true);
  const [showLines96, setShowLines96] = useState(true);
  const [showLines72, setShowLines72] = useState(true);
  const [showLines64, setShowLines64] = useState(true);
  const [showLines48, setShowLines48] = useState(true);
  const [showLines36, setShowLines36] = useState(true);
  const [showLines24, setShowLines24] = useState(true);
  const [showLines16, setShowLines16] = useState(true);
  const [showLines12, setShowLines12] = useState(true);
  const [showLines8, setShowLines8] = useState(true);
  const [showLines4, setShowLines4] = useState(true);
  const [showLines2, setShowLines2] = useState(true);
  const [showLines1, setShowLines1] = useState(true);
  const [showPonLayer, setShowPonLayer] = useState(false);
  const [showKtvLayer, setShowKtvLayer] = useState(false);
  const [showEtherLayer, setShowEtherLayer] = useState(false);
  
  const [showLineDenomination, setShowLinesDenomination] = useState(false);
  const [lengthCable, setLengthCable] = useState(0);
  const [linePoints, setLinePoints] = useState([]);
  const [showLinesTypeSolid, setShowLinesTypeSolid] = useState(true);
  const [showLinesTypeBasement, setShowLinesTypeBasement] = useState(false);
  const [showLinesTypeLoft, setShowLinesTypeLoft] = useState(false);
  const [showLinesTypeFacade, setShowLinesTypeFacade] = useState(false);
  const [showLinesTypeDashed, setShowLinesTypeDashed] = useState(true);
  const [linkEditing, setLinkEditing] = useState(false);
  const [markerEditing, setMarkerEditing] = useState('');
  const [isComponentСhangeCoor, setIsComponentСhangeCoor] = useState(false);
  const [isComponentСhangeCoorPillar, setIsComponentСhangeCoorPillar] = useState(false);
  const [isComponentСhangeCoorCoupling, setIsComponentСhangeCoorCoupling] = useState(false);
  const [isComponentСhangeCoorFob, setIsComponentСhangeCoorFob] = useState(false);
  const [isComponentСhangeCoorPonBox, setIsComponentСhangeCoorPonBox] = useState(false);

  const [linkEditingProblem, setLinkEditingProblem] = useState(false);
  const[lineProblemId, setLineProblemId] = useState();
  const [markerProblemLineCoordinates, setMarkerProblemLineCoordinates] = useState(null);
  const [flagTettytoryEditingProblemLine, setFlagTettytoryEditingProblemLine] = useState('');
  const linkEditingProblemRef = useRef(linkEditingProblem);
  const [problemCableData, setProblemCableData] = useState([]);

  const [visibleNumberPonBox, setVisibleNumberPonBox] = useState(true);


useEffect(() => {
    linkEditingProblemRef.current = linkEditingProblem;
}, [linkEditingProblem]);


  //marker manhole
  const [markersManhole, setManholeMarkers] = useState([]);
  const [coordinatesManhole, setCoordinatesManhole] = useState([]);
  const [manholeMarker, setIsManholeDrawing] = useState(false);
  const [wellData, setWellData] = useState([]);

  //marker Pillar
  const [markersPillar, setPillarMarkers] = useState([]);
  const [coordinatesPillar, setCoordinatesPillar] = useState([]);
  const [pillarMarker, setIsPillarDrawing] = useState(false);
  const [pillarData, setPillarData] = useState([]);  

  //marker Coupling
  const [markersCoupling, setCouplingMarkers] = useState([]);
  const [coordinatesCoupling, setCoordinatesCoupling] = useState([]);
  const [couplingMarker, setIsCouplingDrawing] = useState(false);
  const [couplingLocationData, setCouplingLocationData] = useState([]);

  //marker Fob
  const [markersFob, setFobMarkers] = useState([]);
  const [coordinatesFob, setCoordinatesFob] = useState([]);
  const [fobMarker, setIsFobDrawing] = useState(false);
  const [fobLocationData, setFobLocationData] = useState([]);
  const [selectedRankFob, setSelectedRankFob] = useState(null);

 //marker PonBox
  const [markersPonBox, setPonBoxMarkers] = useState([]);
  const [coordinatesPonBox, setCoordinatesPonBox] = useState([]);
  const [ponBoxMarker, setIsPonBoxDrawing] = useState(false);
  const [ponBoxLocationData, setPonBoxLocationData] = useState([]);

  // KTV
  const [ktvAmplifierData, setktvAmplifierData] = useState([]);
  const [ktvOpData, setktvOpData] = useState([]);

  // DIVIDER
  const [dividerData, setDividerData] = useState([]);

  // фильтр
  const [loadingSummit, setLoadingSummit] = useState(false);
  const [loadingCunton, setLoadingCunton] = useState(false);
  const [position, setPosition] = useState([0, 0]); 
//#endregion





  //#region ФИЛЬТР
    // фильтр  
    const [layersVisibility, setLayersVisibility] = useState({
      icon100pab: false,
      iconKp: false,
      icon3k: true,
      icon30k: true,
      iconSummit: true,
    });

    const [layersVisibilityCommunications, setLayersVisibilityCommunications] = useState({
      iconPillar: false,
      iconManhole: true,
      iconCoupling: true,
      iconFob: true,
      iconCouplingCanton: true,
      iconPonBox: true,
      iconAmplifier: true,
      iconOp: true,
      iconDividerApc: true,
      iconDividerUpc: true,
    });
   
    const toggleLayerVisibility = (layer) => {
      setLayersVisibility(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

    const toggleLayerVisibilityCommunications = (layer) => {
      setLayersVisibilityCommunications(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

    const handleNumberPonBoxCheckboxChange = () => {
      setVisibleNumberPonBox(!visibleNumberPonBox); 
    };

    const handleLineCheckboxChange = () => {
      setShowLines(!showLines); 
    };

    const handleLine48CheckboxChange = () => {
      setShowLines48(!showLines48); 
    };

    const handleLine24CheckboxChange = () => {
      setShowLines24(!showLines24); 
    };

    const handleLine12CheckboxChange = () => {
      setShowLines12(!showLines12); 
    };

    const handleLine36CheckboxChange = () => {
      setShowLines36(!showLines36); 
    };

    const handleLine64CheckboxChange = () => {
      setShowLines64(!showLines64); 
    };

    const handleLine72CheckboxChange = () => {
      setShowLines72(!showLines72); 
    };

    const handleLine96CheckboxChange = () => {
      setShowLines96(!showLines96); 
    };

    const handleLine16CheckboxChange = () => {
      setShowLines16(!showLines16); 
    };

    const handleLine8CheckboxChange = () => {
      setShowLines8(!showLines8); 
    };

    const handleLine4CheckboxChange = () => {
      setShowLines4(!showLines4); 
    };

    const handleLine2CheckboxChange = () => {
      setShowLines2(!showLines2); 
    };

    const handleLine1CheckboxChange = () => {
      setShowLines1(!showLines1); 
    };

    const handlePonLayerCheckboxChange = () => {
      setShowPonLayer(!showPonLayer); 
      setShowKtvLayer(false);
      setShowEtherLayer(false);
    };

    const handleKtvLayerCheckboxChange = () => {
      setShowKtvLayer(!showKtvLayer); 
      setShowPonLayer(false);
      setShowEtherLayer(false);
    };

    const handleEtherLayerCheckboxChange = () => {
      setShowEtherLayer(!showEtherLayer); 
      setShowKtvLayer(false);
      setShowPonLayer(false);
    };

    const handleLinesDenominationCheckboxChange = () => {
      setShowLinesDenomination(!showLineDenomination); 
    };

    const handleLineTypeSolidCheckboxChange = () => {
      setShowLinesTypeSolid(!showLinesTypeSolid); 
    };

    const handleLineTypeDashedCheckboxChange = () => {
      setShowLinesTypeDashed(!showLinesTypeDashed); 
    };

    const handleLineTypeBasementCheckboxChange = () => {
      setShowLinesTypeBasement(!showLinesTypeBasement); 
      setShowLinesTypeFacade(false);
      setShowLinesTypeLoft(false);
    };

    const handleLineTypeFacadeCheckboxChange = () => {
      setShowLinesTypeFacade(!showLinesTypeFacade); 
      setShowLinesTypeBasement(false);
      setShowLinesTypeLoft(false);
    };

    const handleLineTypeLoftCheckboxChange = () => {
      setShowLinesTypeLoft(!showLinesTypeLoft); 
      setShowLinesTypeBasement(false);
      setShowLinesTypeFacade(false);
    };

    const handlePoligonCantonChange = () => {
      setShowPolygonsCanton(!showPolygonsCanton); 
    };

    const handlePoligonAreaChange = () => {
      setShowPolygonsArea(!showPolygonsArea); 
    };

    const handleHousesChange = () => {
      setShowHouses(!showHouses); 
      setShowHousesNoActiv(false); 
      setShowHousesActiv(false);
    };

    const handleHousesActivChange = () => {
      setShowHousesActiv(!showHousesActiv); 
      setShowHousesNoActiv(false);
      setShowHouses(false);
    };

    const handleHousesNoActivChange = () => {
      setShowHousesNoActiv(!showHousesNoActiv); 
      setShowHousesActiv(false);
      setShowHouses(false);
    };

    const changeLinkEditing = (id, status, marker) => {
      setPolylinePoints([]);
      setLineId();
      setMarkerEditing('');
      setLinkEditing(status);  

      if (groupedCoordinatesWithColorTypeAndWidth[id]) {
        setLineId(id);
        setMarkerEditing(marker);
        setPolylinePoints(groupedCoordinatesWithColorTypeAndWidth[id].coordinates);
      }
    };

  


  useEffect(() => {
      loadingCanton(setCanton); 
      loadingCity(setCity); 
    }, []); 

  
    
    async function handleCantonChange(selectedOption) {
      setSelectCityIsСhange(null);
      setSelectedCanton(selectedOption.value);
      setSelectCantonIsСhange(selectedOption);
      setSelectedRegion(null);
      setSelectedArea(null);
      setHighwayTerritory(false);
      setCantonTerritory(true);

      const regionsData = await loadingRegionsData(selectedOption.value);
        if (regionsData) {
            setRegions(regionsData);
        }
  }

    // загрузка веток в селект
    async function handleRegionChange(event) {
      setSelectedRegion(event.target.value);
      const selectedRegion = event.target.value;
      const areaData = await loadingAreaData(selectedRegion);
      if (areaData) {
        setArea(areaData);
      }
    }
    
    async function handleAreaChange(event) {
      setSelectedArea(event.target.value);
    }

    const cantonFobRefresh = () => {
      GetCantonFobFilterRefreshConstruction(setFobLocationData, setFobMarkers, project.id);
    }; 

    const cantonCouplingRefresh = () => {
      GetCantonCouplingFilterRefreshConstruction(setCouplingLocationData, setCouplingMarkers, project.id);
    }; 

    const cantonPonBoxRefresh = () => {
      GetCantonPonBoxFilterRefreshConstruction(setPonBoxLocationData, setPonBoxMarkers, project.id);
    }; 

    const cantonCablaRefresh = () => {
      GetCableFilterRefreshConstructor(setGroupedCoordinatesWithColorTypeAndWidth, setDescriptionOptic, handleLineClearMap, project.id);
    }; 

     const cantonCablaByIdRefresh = (highwayLineId) => {
       GetCableByIdFilterRefreshConstructor(  highwayLineId, setGroupedCoordinatesWithColorTypeAndWidth,  setDescriptionOptic,  groupedCoordinatesWithColorTypeAndWidth);    
    }; 
   

    const handleClickCanton = () => {      
          GetCantonPoligon( project.canton, project.region, setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth,
               setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setHousesData, project.id, setktvAmplifierData); 
    };

    const handleClickSummit = () => {
    //  GetHighwayFilter( setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
    //                  setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition,setStatusModalTerritory,setDescriptionOptic,setProblemCableData); 
    };

   

     async function handleCityChange(selectedOption) {
      setSelectCantonIsСhange(null);
      setSelectedRegion(null);
      setSelectedArea(null);
      setSelectedCity(selectedOption.value);  
      setSelectCityIsСhange(selectedOption);  
      setCantonTerritory(false);
      setHighwayTerritory(true);
    }
 
    // Обновление центра карты
    useEffect(() => {
      if (position[0] !== 0 || position[1] !== 0) {
        mapRef.current?.setView(position, 14);//13
      }
    }, [position]);
//#endregion
    
  //#region DRAWER
  const toggleViewingDrawer = (isOpen) => () => {
    setOpenViewingDrawer(isOpen);
  }; 

  const toggleEditCantonDrawer = (cantonTerritory, isOpen) => () => {
   // if(!cantonTerritory == false && (role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN)){
       setOpenEditCantonDrawer(isOpen);
   // }else{
   //    setOpenEditCantonDrawer(false);
   // }
  }; 



  //#region MODAL
  const openModalWithContent = (content, markerType) => {
    setModalContent(content);
    setMarkerType(markerType);
    setOpenModal(true);
   
  };


  const toggleModalLog = (isOpen) => () => {
       setOpenModalLog(isOpen);
  }; 

  const handleEditingCancelClick = () => {
    setLineEditing([]);
    setPolylinePoints([]);  
    setLineId();
    setPolylinePoints([]);
    setLinkEditing(false);
  };

  const handleEditingProblemLineCancelClick = () => {
    setLinkEditingProblem(false);
    setMarkerProblemLineCoordinates(null);  
    setFlagTettytoryEditingProblemLine('');
    setLineProblemId();
  };



  const toggleRuler = (isOpen) => () => {
     setRulerStatus(isOpen);
    // if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER){
    //    setRulerStatus(isOpen);
    // }else{
    //   setRulerStatus(false);
    // }
  }; 
//#endregion

  //#region MENU
  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuPosition({ top: event.pageY, left: event.pageX });
  };

  const handleClose = () => {
    setMenuPosition(null);
  };
  //#endregion

  //#region РИСОВАНИЕ
    const handleStartDrawing = () => {
      setIsLineDrawing(true);
    };











    const handleStopDrawing = () => {
        setIsLineDrawing(false);
    };
    
    

  

  //кабель
  const removeLastPoint = () => {
    setLinePoints((prevPoints) => {
      const newPoints = prevPoints.slice(0, -1);
      updateLength(newPoints);
      return newPoints;
    });
  
    setCoordinatesCableLine((prevCoordinates) => {
      if (prevCoordinates && prevCoordinates.length > 0) {
        const newCoordinates = prevCoordinates.slice(0, -1);
        return newCoordinates;
      }
      return prevCoordinates;
    });
  };

  useEffect(() => {  
    if (linePoints.length < coordinatesCableLine.length) {
      setCoordinatesCableLine((prevCoordinates) => {
        const newCoordinates = prevCoordinates.slice(0, -1);
        return newCoordinates;
      });
    }
  }, [linePoints]); 

  const updateLength = (points) => {
    let totalLength = 0; 

    for (let i = 0; i < points.length - 1; i++) {
      const point1 = L.latLng(points[i]);
      const point2 = L.latLng(points[i + 1]);
      totalLength += point1.distanceTo(point2);
    }
    setLengthCable(totalLength.toFixed(2));
  };



  const handleCableSelectChange = (selectedOption) => {
    if (selectedOption === null) {
      // Если пользователь очистил выбор
      setCableOpticId(null);
      setSelectedLineColor(null);
      setSelectedLineWidth(null);
      return;
    }
  
    const [id, color, width, name, fiberQuantity] = selectedOption.value.split(',');
    setCableOpticId(id);
    setSelectedLineColor(color);
    setSelectedLineWidth(width);
  };

  const handleLineStyleSelectChange = (event) => {
    const selectedLineStyle = event.target.value;
    const [id, type,kind] = selectedLineStyle.split(','); 
    setCableTypeId(id);
    setCableKind(kind);  
  };
  //#endregion
  
 //#region КОЛОДЕЦ

  //marker колодец

  const toggleManholeMarker = () => {
    setIsManholeDrawing(!manholeMarker);     
  };

  const removeManholeMarker = (index) => {  
    const newManholeMarkers = markersManhole.filter((marker, idx) => idx !== index);
    const newManholeCoordinates = coordinatesManhole.filter((coordinate, idx) => idx !== index);
    setManholeMarkers(newManholeMarkers);
    setCoordinatesManhole(newManholeCoordinates);
  };
//#endregion

//#region ОПОРА

  const togglePillarMarker = () => {
    setIsPillarDrawing(!pillarMarker);
  };

  const removePillarMarker = (index) => {
      const newPillarMarkers = markersPillar.filter((marker, idx) => idx !== index);
      const newPillarCoordinates = coordinatesPillar.filter((coordinate, idx) => idx !== index);
      setPillarMarkers(newPillarMarkers);
      setCoordinatesPillar(newPillarCoordinates);    
  };
//#endregion

 //#region МУФТА

  const toggleCouplingMarker = () => {
    setIsCouplingDrawing(!couplingMarker);
  };

  const removeCouplingMarker = (index) => {  
      const newCouplingMarkers = markersCoupling.filter((marker, idx) => idx !== index);
      const newCouplingCoordinates = coordinatesCoupling.filter((coordinate, idx) => idx !== index);
      setCouplingMarkers(newCouplingMarkers);
      setCoordinatesCoupling(newCouplingCoordinates);

      
  };
//#endregion

//#region ФОБ

  const toggleFobMarker = () => {
    setIsFobDrawing(!fobMarker);
  };

  const removeFobMarker = (index) => {
      const newFobMarkers = markersFob.filter((marker, idx) => idx !== index);
      const newFobCoordinates = coordinatesFob.filter((coordinate, idx) => idx !== index);
      setFobMarkers(newFobMarkers);
      setCoordinatesFob(newFobCoordinates);    
  }; 
 //#endregion

 //#region Pon-box

 const togglePonBoxMarker = () => {
  setIsPonBoxDrawing(!ponBoxMarker);
};

const removePonBoxMarker = (index) => {
    const newPonBoxMarkers = markersPonBox.filter((marker, idx) => idx !== index);
    const newPonBoxCoordinates = coordinatesPonBox.filter((coordinate, idx) => idx !== index);
    setPonBoxMarkers(newPonBoxMarkers);
    setCoordinatesPonBox(newPonBoxCoordinates);    
}; 
//#endregion

 

 const handleChangeRankComponentCoupling = (event) => {
  const selectedRankComponent = event.target.value;
  setSelectedRankCoupling(selectedRankComponent);
};



const handleChangeRankComponentFob = (event) => {
 const selectedRankComponent = event.target.value;
 setSelectedRankFob(selectedRankComponent);
};



const enableRuler = () => {
  if (mapRef.current) {
    const map = mapRef.current;

    if (polylineHandlerRef.current) {
      return; 
    }

    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }

  
    const polylineHandler = new CustomDrawPolyline(map, {
      shapeOptions: {
        color: '#172c85',
        weight: 4
      }
    });

   
    polylineHandlerRef.current = polylineHandler;
    polylineHandler.enable();

    
    map.on('draw:created', (e) => {
      const layer = e.layer;
      if (layer instanceof L.Polyline) {
        drawnItemsRef.current.addLayer(layer); 
      }

      if (polylineHandlerRef.current) {
        polylineHandlerRef.current.disable(); 
        polylineHandlerRef.current = null; 
      }
    });
  }
};




const resetRuler = () => {
  if (drawnItemsRef.current) {
    drawnItemsRef.current.clearLayers(); 
  }

  if (polylineHandlerRef.current) {
    polylineHandlerRef.current.disable(); 
    polylineHandlerRef.current = null; 
  }
};

useEffect(() => {
  if (mapRef.current) {
    const map = mapRef.current;
    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }
  }
}, []);

// очищаем карту
const handleClearMap2 = () => {
  const map = mapRef.current; // Получаем объект карты
  if (map) {
    // Удаляем все пользовательские слои
    map.eachLayer((layer) => {
      if (!(layer instanceof L.TileLayer)) {
        map.removeLayer(layer);
      }
    });
  }
};

const removeLineFromMap = (highwayLineId) => {
  // Пройдись по ссылкам к слоям карты и удали нужную по id
  // Например, если ты используешь Leaflet:
  const layer = mapRef.current[highwayLineId];
  if (layer) {
    mapRef.removeLayer(layer);
    delete mapRef.current[highwayLineId];
  }
};


const handleLineClearMap = async () => {
   setGroupedCoordinatesWithColorTypeAndWidth([]);
      setDescriptionOptic({});
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);

};

const handleLineClearMapTEST = (highwayLineId) => {
   setGroupedCoordinatesWithColorTypeAndWidth(prev => {
    const updated = { ...prev };
    delete updated[highwayLineId];
    return updated;
  });

  setDescriptionOptic(prev => prev.filter(item => item.highwayLineId !== highwayLineId));
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);
}



if (!project) {
  return <div>Загрузка проекта...</div>;
}




  return (
    
    <div className="divMainOptic" >

      <div style={{ display: 'flex', height: '100vh' }} onContextMenu={handleContextMenu} >
        <div style={{ flexGrow: 0, display: 'flex', flexDirection: 'column' }}>

          <Tooltip title="Фильтр" arrow>
            <IconButton onClick={toggleViewingDrawer(true)}>
              <VisibilityRoundedIcon />
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          

          <Tooltip title="Режим внесения" arrow>
            <IconButton onClick={toggleEditCantonDrawer(cantonTerritory, true)}>
              <SwapCallsRoundedIcon />
            </IconButton>
          </Tooltip>
         
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Смета" arrow>
             <IconButton onClick={toggleModalLog(true)}>
              <FormatListNumberedIcon/>
            </IconButton> 
          </Tooltip>
          <hr style={{margin: "0px"}}/>
          <Tooltip title="Линейка" arrow>
            <IconButton onClick={toggleRuler(true)}>
              <SquareFootIcon/>
            </IconButton>
          </Tooltip>
          
          <hr style={{margin: "0px"}}/>
          
        </div>
        <DrawerEditComponent
          openEditCantonDrawer={openEditCantonDrawer}
          toggleEditCantonDrawer={toggleEditCantonDrawer}
          handleCableSelectChange={handleCableSelectChange}
          handleLineStyleSelectChange={handleLineStyleSelectChange}
          isLineDrawing={isLineDrawing}
          handleStartDrawing={handleStartDrawing}
          handleStopDrawing={handleStopDrawing}
          toggleManholeMarker={toggleManholeMarker}
          manholeMarker={manholeMarker}
          togglePillarMarker={togglePillarMarker}
          pillarMarker={pillarMarker}
          toggleCouplingMarker={toggleCouplingMarker}
          couplingMarker={couplingMarker}
          toggleFobMarker={toggleFobMarker}
          fobMarker={fobMarker}
          coordinatesManhole={coordinatesManhole}
          setCoordinatesManhole={setCoordinatesManhole}
          coordinatesPillar={coordinatesPillar}
          setCoordinatesPillar={setCoordinatesPillar}
          coordinatesCoupling={coordinatesCoupling}
          setCoordinatesCoupling={setCoordinatesCoupling}
          coordinatesFob={coordinatesFob}
          setCoordinatesFob={setCoordinatesFob}
          coordinatesCableLine={coordinatesCableLine}
          setCoordinatesCableLine={setCoordinatesCableLine}         
          cableOpticId={cableOpticId}
          cableTypeId={cableTypeId}
         // cantonRefresh={cantonRefresh}
          setLengthCable={setLengthCable}
          lengthCable={lengthCable}
          selectedRankCouling={selectedRankCouling}
          setSelectedRankCoupling={setSelectedRankCoupling}
          handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
          selectedRankFob={selectedRankFob}
          setSelectedRankFob={setSelectedRankFob}
          handleChangeRankComponentFob={handleChangeRankComponentFob}
          user={user}
          selectedCity={selectedCity}
          highwayTerritory={highwayTerritory}
          togglePonBoxMarker={togglePonBoxMarker}
          ponBoxMarker={ponBoxMarker}
          coordinatesPonBox={coordinatesPonBox}
          setCoordinatesPonBox={setCoordinatesPonBox}
          cantonFobRefresh={cantonFobRefresh}
          cantonCouplingRefresh={cantonCouplingRefresh}
          // cantonWellRefresh={cantonWellRefresh}
          // cantonPillarRefresh={cantonPillarRefresh}
          cantonPonBoxRefresh={cantonPonBoxRefresh}
          cantonCablaRefresh={cantonCablaRefresh}
          selectedCanton={selectedCanton}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          projectId={project.id}
          cantonCablaByIdRefresh={cantonCablaByIdRefresh}
        />
       

       
        <DrawerViewingConstruct
          openViewingDrawer={openViewingDrawer}
          toggleViewingDrawer={toggleViewingDrawer}
          loadingSummit={loadingSummit}
          loadingCunton={loadingCunton}
          toggleLayerVisibility={toggleLayerVisibility}
          layersVisibility={layersVisibility}
          canton={canton}
          handleCantonChange={handleCantonChange}
          handleRegionChange={handleRegionChange}
          selectedRegionRef={selectedRegionRef}
          regions={regions}
          selectedAreaRef={selectedAreaRef}
          area={area}
         handleClickCanton={handleClickCanton}
          layersVisibilityCommunications={layersVisibilityCommunications}
          toggleLayerVisibilityCommunications={toggleLayerVisibilityCommunications}
          handleLineCheckboxChange={handleLineCheckboxChange}
          showLines={showLines} 
          city={city}
          handleCityChange={handleCityChange} 
          handleClickSummit={handleClickSummit}
          handleAreaChange={handleAreaChange}
          handleLine48CheckboxChange={handleLine48CheckboxChange}
          showLines48={showLines48}
          handleLine24CheckboxChange={handleLine24CheckboxChange}
          showLines24={showLines24}
          handleLine12CheckboxChange={handleLine12CheckboxChange}
          showLines12={showLines12}
          handleLine8CheckboxChange={handleLine8CheckboxChange}
          showLines8={showLines8}
          handleLine4CheckboxChange={handleLine4CheckboxChange}
          showLines4={showLines4}
          handleLine2CheckboxChange={handleLine2CheckboxChange}
          showLines2={showLines2}
          handleLine1CheckboxChange={handleLine1CheckboxChange}
          showLines1={showLines1}
          handleLine16CheckboxChange={handleLine16CheckboxChange}
          showLines16={showLines16}
          handleLine36CheckboxChange={handleLine36CheckboxChange}
          showLines36={showLines36}
          handleLine64CheckboxChange={handleLine64CheckboxChange}
          showLines64={showLines64}
          handleLine72CheckboxChange={handleLine72CheckboxChange}
          showLines72={showLines72}
          handleLine96CheckboxChange={handleLine96CheckboxChange}
          showLines96={showLines96}
          handlePonLayerCheckboxChange={handlePonLayerCheckboxChange}
          showPonLayer={showPonLayer}
          handleLinesDenominationCheckboxChange={handleLinesDenominationCheckboxChange}
          showLineDenomination={showLineDenomination}
          selectCityIsСhange={selectCityIsСhange}
          selectCantonIsСhange={selectCantonIsСhange}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          showLinesTypeSolid={showLinesTypeSolid}
          showLinesTypeDashed={showLinesTypeDashed}
          handleLineTypeSolidCheckboxChange={handleLineTypeSolidCheckboxChange}
          handleLineTypeDashedCheckboxChange={handleLineTypeDashedCheckboxChange}
          handlePoligonCantonChange={handlePoligonCantonChange}
          showPolygonsCanton={showPolygonsCanton}
          handlePoligonAreaChange={handlePoligonAreaChange}
          showPolygonsArea={showPolygonsArea}
          handleKtvLayerCheckboxChange={handleKtvLayerCheckboxChange}
          showKtvLayer={showKtvLayer}
          handleEtherLayerCheckboxChange={handleEtherLayerCheckboxChange}
          showEtherLayer={showEtherLayer}
          handleLineTypeBasementCheckboxChange={handleLineTypeBasementCheckboxChange}
          showLinesTypeBasement={showLinesTypeBasement}
          handleLineTypeFacadeCheckboxChange={handleLineTypeFacadeCheckboxChange}
          showLinesTypeFacade={showLinesTypeFacade}
          handleLineTypeLoftCheckboxChange={handleLineTypeLoftCheckboxChange}
          showLinesTypeLoft={showLinesTypeLoft}
          handleHousesChange={handleHousesChange}
          showHouses={showHouses}
          handleNumberPonBoxCheckboxChange={handleNumberPonBoxCheckboxChange}
          visibleNumberPonBox={visibleNumberPonBox}
          handleHousesNoActivChange={handleHousesNoActivChange}
          showHousesActiv={showHousesActiv}
          handleHousesActivChange={handleHousesActivChange}
          showHousesNoActiv={showHousesNoActiv}
        /> 
        
        {/* menu на мышку */}
        <CustomMenuMouse
          menuPosition={menuPosition}
          handleClose={handleClose} 
          handleStopDrawing={handleStopDrawing}
          open={Boolean(menuPosition)} 
          isLineDrawing={isLineDrawing}
          removeLastPoint={removeLastPoint}
        />

      {/* div отображение выбранной территории */}
      <ProjectInfo
        project={project}
        generateLink={generateLink}
        copied ={copied}
       
      />

    {/* отображение длинны кабеля при рисовании */}
    <ShowLengthCable
        isLineDrawing={isLineDrawing}
        lengthCable={lengthCable}
        lengthCableSegment={lengthCableSegment}
    />

     {/* отображение линейки */}
     <ShowRuler
        rulerStatus={rulerStatus}
        setRulerStatus={setRulerStatus}
        enableRuler={enableRuler}
        resetRuler={resetRuler}
      />

     {/* отображение длинны кабеля при рисовании */}
     <EditingLineCableConstruct
        isEditing={linkEditing} 
        setLinkEditing={setLinkEditing}
        setPolylinePoints={setPolylinePoints}  
        lineEditing={lineEditing}
        lengthCableEditing={lengthCableEditing}
        lineId={lineId}
       // user={role.user}
        setLineId={setLineId}
        //highwayRefresh={highwayRefresh}
        setLineEditing={setLineEditing}
        markerEditing={markerEditing}
        cantonRefresh={cantonCablaRefresh}
        handleEditingCancelClick={handleEditingCancelClick}
    />

     

<MapContainer
  center={[48.749, 31.267]}
  zoom={6}
  minZoom={6}
  style={{ flex: '1', borderRadius: '10px' }}
  ref={mapRef}
  whenCreated={(mapInstance) => { mapRef.current = mapInstance; }}
>

<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  maxZoom={19.5} 
/>

         {/* рисуем оборудку */}   
          <GetHousesMapLocation
          layersVisibility={layersVisibility}
          isLineDrawing={isLineDrawing}
          mapRef={mapRef}
          cantonTerritory={cantonTerritory}
          showPolygonsCanton={showPolygonsCanton}
          showPolygonsArea={showPolygonsArea} 
          //   showPolygonsCanton={true}
          // showPolygonsArea={true}   
          housesData={housesData}
          showHouses={showHouses} 
          showHousesActiv={showHousesActiv}
          showHousesNoActiv={showHousesNoActiv}
        />    
        


        {/* Отображение кабельных линий из БД */}       
        <CableShowDisplayConstruct
          showLines={showLines}
          showLines12={showLines12}
          showLines24={showLines24}
          showLines48={showLines48}
          showLines8={showLines8}
          showLines4={showLines4}
          showLines2={showLines2}
          showLines1={showLines1}
          showLines16={showLines16}
          showLines36={showLines36}
          showLines64={showLines64}
          showLines72={showLines72}
          showLines96={showLines96}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          statusModalTerritory={statusModalTerritory}
          descriptionOptic={descriptionOptic}
          openModalWithContent={openModalWithContent}
          showLinesTypeSolid={showLinesTypeSolid}
          showLinesTypeDashed={showLinesTypeDashed}
          onPolylineRef={handlePolylineRef} // Передаём функцию для получения рефов
          showLineDenomination={showLineDenomination}
          showPonLayer={showPonLayer}
          showKtvLayer={showKtvLayer}
          showEtherLayer={showEtherLayer}
          showLinesTypeBasement={showLinesTypeBasement}
          showLinesTypeFacade={showLinesTypeFacade}
          showLinesTypeLoft={showLinesTypeLoft}
        />

       
  
        {/*рисуем линк*/}
        <DrawingLineHandler
          isLineDrawing={isLineDrawing} 
          color={selectedLineColor} 
          weight={selectedLineWidth} 
          setCoordinatesCableLine={setCoordinatesCableLine}
          cableKind={cableKind}
          linePoints={linePoints}
          setLinePoints={setLinePoints}
          removeLastPoint={removeLastPoint}
          updateLength={updateLength}
          switchesData={switchesData}
          selectedCanton={selectedCanton}
          selectedCity={selectedCity}
          setLengthCableSegment={setLengthCableSegment}   
          housesData={housesData}     
        />



{/* Редактирование линка Canton*/}
<FeatureGroup>
  {markerEditing === CONST_CANTON && (
    <LinkEditingCanton
      polylinePoints={polylinePoints}
      setPolylinePoints={setPolylinePoints}
      editMode={linkEditing}
      setLengthCableEditing={setLengthCableEditing}
      setLineEditing={setLineEditing}
      switchesData={switchesData}
      selectedCanton={selectedCanton}
      housesData={housesData}  
      polyline={polyline}
      setPolyline={setPolyline}
    /> 
  )}
</FeatureGroup>

   
       {/*Coupling в режиме редактирования*/}
       <MarkerPoligonToClick
        switchesData={switchesData} 
        marker={couplingMarker}
        markers={markersCoupling}
        setMarkers={setCouplingMarkers}
        coordinates={coordinatesCoupling}
        setCoordinates={setCoordinatesCoupling}
        selectedCanton={selectedCanton}
        housesData={housesData}
      />
       <MarkersEditingCoupling
         markers={markersCoupling}
         selectedRankCouling={selectedRankCouling}
         removeMarker={removeCouplingMarker}
         type={COUPLING_FLAG}
      />

         {/* Fob в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={fobMarker}
          markers={markersFob}
          setMarkers={setFobMarkers}
          coordinates={coordinatesFob}
          setCoordinates={setCoordinatesFob}
          selectedCanton={selectedCanton}
          housesData={housesData}
        />

       <MarkersEditingFob
        markers={markersFob}
        selectedRankFob={selectedRankFob}
        removeMarker={removeFobMarker}
        type={FOB_FLAG}
      />

         {/* Pon-box в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={ponBoxMarker}
          markers={markersPonBox}
          setMarkers={setPonBoxMarkers}
          coordinates={coordinatesPonBox}
          setCoordinates={setCoordinatesPonBox}
          selectedCanton={selectedCanton}
          housesData={housesData}
        />

       <MarkersEditingPonBox
        markers={markersPonBox}
        removeMarker={removePonBoxMarker}
        type={PON_BOX_FLAG}
      />

      {/* Отображение муфт */}
      <MarkersTwoIconViewingCouplingConstruct
        data={couplingLocationData}
        iconCoupling={iconCoupling}
        iconCouplingCanton={iconCouplingCanton}
        layersVisibilityCommunications={layersVisibilityCommunications.iconCoupling}
        isLineDrawing={isLineDrawing}
        flag={couplingMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_COUPLING}
        cantonFlag={CONST_CANTON_COUPLING}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        isComponentСhangeCoor={isComponentСhangeCoorCoupling}
        setIsComponentСhangeCoor={setIsComponentСhangeCoorCoupling}
        cantonRefresh={cantonCouplingRefresh}
        // highwayRefresh={highwayRefresh}
        //user={role.user}
        type={COUPLING}
      />     

      {/*  Отображение фобов */}
      <MarkersTwoIconViewingFobConstruction
        data={fobLocationData}
        iconCoupling={iconFob}
        iconCouplingCanton={iconFobCanton}
        layersVisibilityCommunications={layersVisibilityCommunications.iconFob}
        isLineDrawing={isLineDrawing}
        flag={fobMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_FOB}
        cantonFlag={CONST_CANTON_FOB}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        isComponentСhangeCoor={isComponentСhangeCoorFob}
        setIsComponentСhangeCoor={setIsComponentСhangeCoorFob}
        cantonRefresh={cantonFobRefresh}
        // highwayRefresh={highwayRefresh}
        // user={role.user}
        type={FOB}
      />     

   

       {/* Отображение Пон-бокс */}      
      <MarkersViewingPonBoxConstructor
        data={ponBoxLocationData}
        icon={iconPonBox}
        layersVisibilityCommunications={layersVisibilityCommunications.iconPonBox}
        isLineDrawing={isLineDrawing}
        flag={ponBoxMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={'null'}
        cantonFlag={CONST_CANTON_PON_BOX}
        position={position}
        type={PON_BOX}
        // user={role.user}
        cantonRefresh={cantonPonBoxRefresh}
        // highwayRefresh={highwayRefresh}
        isComponentСhangeCoor={isComponentСhangeCoorPonBox}
        setIsComponentСhangeCoor={setIsComponentСhangeCoorPonBox}
        showPonLayer={showPonLayer}
        showKtvLayer={showKtvLayer}
        showEtherLayer={showEtherLayer}
        visibleNumberPonBox={visibleNumberPonBox}
      />

       {/*  Отображение PassiveNode Amplifier */}
      <MarkersAmplifierPassiveNode
        data={ktvAmplifierData}
      />     

    
      

  </MapContainer>
</div>

      {/* Описание компонентов DialogDescription */}
      <DescriptionComponentModalConstr 
        open={openModal}
        onClose={() => setOpenModal(false)}
        content={modalContent} 
        markerType={markerType}
        isLineDrawing={isLineDrawing}
        couplingMarker={couplingMarker}
        fobMarker={fobMarker}
        ponBoxMarker={ponBoxMarker}
        changeLinkEditing={changeLinkEditing}
        linkEditing={linkEditing}
        cantonFobRefresh={cantonFobRefresh}
        cantonCouplingRefresh={cantonCouplingRefresh}
        cantonPonBoxRefresh={cantonPonBoxRefresh}
        cantonCablaRefresh={cantonCablaRefresh}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
      />

    

       {/* Отображение Логов */}
       <ModalEstimate
          open={openModalLog}
          onClose={() => setOpenModalLog(false)}
          projectId={project.id}
        />
        
    </div>
  );
}

export default MainConstructorMap;
